import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_9: FaireProductEntity = {
  token: "plant-dyed-9",
  type: "product",
  name: "Handwoven Throw Blanket",
  brandName: "Trek Light",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/59117d9a3a9d737c20da5749db6ee9408e12ea5cc3efbbba79010bfbfeef8a4c.png",
  priceDollars: 64,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/59117d9a3a9d737c20da5749db6ee9408e12ea5cc3efbbba79010bfbfeef8a4c.png",
  weight: 2,
  dimensions: {
    width: 50,
    height: 60,
    depth: 2,
  },
  description: "Handwoven throw blanket with plant-dyed colors",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "handwoven",
    "blanket",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
